import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "auth/useAuth";
import PropTypes from "prop-types";
import { useProfileCheck } from "../../shared/hooks/useProfileCheck";
import LoadingSpinner from "../../shared/components/LoadingSpinner";

/**
 * Guards pages that need a complete profile (name, phone, city). When the
 * profile is incomplete the user is sent to /profile with the list of
 * missing fields, which the Profile page shows inline.
 */
const ProfileRequiredRoute = ({ children }) => {
  const auth = useAuth();
  const { hasProfile, missingFields, isLoading } = useProfileCheck();
  const location = useLocation();

  if (auth.isLoading || isLoading || !auth.isAuthenticated) {
    return <div className="page-content"><LoadingSpinner /></div>;
  }

  if (!hasProfile) {
    return (
      <Navigate
        to="/profile"
        replace
        state={{ reason: "profile-required", missing: missingFields, from: location.pathname }}
      />
    );
  }

  return children;
};

ProfileRequiredRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProfileRequiredRoute;
